/**
 * StagingBanner — fixed yellow banner shown only in staging environments.
 * Renders when VITE_ENV==='staging' or hostname includes 'staging'.
 */
export default function StagingBanner() {
  const isStaging =
    import.meta.env.VITE_ENV === 'staging' ||
    (typeof window !== 'undefined' && window.location.hostname.includes('staging'));

  if (!isStaging) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#f59e0b', color: '#000', textAlign: 'center',
      padding: '4px 0', fontSize: 12, fontWeight: 700, letterSpacing: 1,
    }}>
      STAGING ENVIRONMENT
    </div>
  );
}
